<ng-template [ngIf]="disabled">
    <input type="text" class="form-control" [value]="tipoClassificacao?.nome" disabled="disabled" readonly="readonly">
</ng-template>

<ng-template [ngIf]="!disabled">
    <select 
        #select
        class="form-control" 
        [name]="name"
        [id]="id"
        [required]="required"
        [ngModel]="ngModel || ''" 
        (ngModelChange)="onChange($event ? $event : null)">
        <option value="" *ngIf="canSelectNull || (required && !ngModel)"></option>

        <ng-template [ngIf]="groupByCadastro">
            <optgroup *ngFor="let grupo of grupos" label="{{grupo.cadastro?.nome | uppercase}}">
                <option *ngFor="let tipo of grupo.tiposClassificacoes" [ngValue]="tipo.id" [disabled]="isSituacaoInativo(tipo.situacao)">{{tipo.nome}}</option>
            </optgroup>
        </ng-template>
        <ng-template [ngIf]="!groupByCadastro">
            <ng-template ngFor let-grupo [ngForOf]="grupos">
                <option *ngFor="let tipo of grupo.tiposClassificacoes" [ngValue]="tipo.id" [disabled]="isSituacaoInativo(tipo.situacao)">{{tipo.nome}}</option>
            </ng-template>
        </ng-template>        
    </select>  
</ng-template>
